export default __webpack_public_path__ + "static/media/ico-concierge.5cfc18a6.svg";